import { render, staticRenderFns } from "./ProductThumbnail2.vue?vue&type=template&id=0319ef50&scoped=true&"
import script from "./ProductThumbnail2.vue?vue&type=script&lang=ts&"
export * from "./ProductThumbnail2.vue?vue&type=script&lang=ts&"
import style0 from "./ProductThumbnail2.vue?vue&type=style&index=0&id=0319ef50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0319ef50",
  null
  
)

export default component.exports